import * as React from "react";
import { PlayerComponentProps, PlayerComponentState, PlayerComponentHandler } from "./playercomponent";
import { PlayerComponentCSSStyle } from "./playercss";
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';

export class PlayerView extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
    }

    draw(uiProps: PlayerComponentProps, uiState: PlayerComponentState, cssStyle: PlayerComponentCSSStyle): JSX.Element | boolean
    {
       super.draw(uiProps, uiState, cssStyle);

       return (
            <div style={cssStyle.getPlayDivCSSStyle()} >
            {
               !uiState.isPlaying ? 
                 <img onClick={this.onPlayClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage(uiProps.playIconName)} />
                 :
                 <img onClick={this.onStopClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage(uiProps.pauseIconName)} />
            }
            </div>);
    }

    getUIComponentHandler(): PlayerComponentHandler
    {
        return super.getUIComponentHandler() as PlayerComponentHandler;
    }

    onPlayClicked(e: any)
    {
        e.stopPropagation();
        this.getUIComponentHandler().onPlayClicked();
    }

    onStopClicked(e: any)
    {
        e.stopPropagation();
        this.getUIComponentHandler().onStopClicked();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerview.tsx